// extracted by mini-css-extract-plugin
export default {"saveAndGoBtnStyles":"CredentialDialog_saveAndGoBtnStyles__EZrUo"};